/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.sailboat\":\"To fugler og en seilebåt på vannet\"}");